import PeopleFields from './PeopleFields';

export default PeopleFields;
